module.exports = __webpack_public_path__ + "img/codetest_add.8e44674a.svg";